import React from 'react';

import AppInfoOverviewComponent from './AppInfoOverviewComponent';
import NotificationAlertComponent from './NotificationAlertComponent';
import SentimentBreakdownComponent from './SentimentBreakdownComponent';
import SentimentGaugeComponent from './SentimentGaugeComponent';
import TopKeywordsComponent from './TopKeywordsComponent';
import AppRatingComponent from './AppRatingComponent';

import { Avatar, Card, Chip, Divider, Typography } from '@mui/joy';
import { cardStyles } from '../../styles/cardStyles';
import InfoTooltipComponent from '../InfoTooltipComponent';

const helper = require('../../Helpers/helpers');

function DashboardComponent(app: any) {

    const stores = () => {
        const availableStores = [
            app.app.appleappid && 'applestore',
            app.app.androidpackageid && 'playstore',
            app.app.app_gallery_id && 'appgallery'
        ].filter(Boolean);

        if (!availableStores.length) return null;

        return (
            <span className="mr-3">
                {availableStores.map((store, index) => (
                    <span key={store}>
                        {index > 0 && <span> + </span>}
                        {helper.iconFor(store, 18)} {store === 'applestore' ? 'iOS' : store === 'playstore' ? 'Google Play' : 'App Gallery'}
                    </span>
                ))}
            </span>
        );
    };

    const getAppSummary = () => {
        const summary = app.app.apple_summary || app.app.android_summary || app.app.app_gallery_summary;
        if (!summary) return null;

        const firstSentence = summary.match(/^[^.!?]+[.!?]/);
        return firstSentence ? firstSentence[0] : summary;
    }

    return (
        <div className=''>
            {/* App Identification */}
            <div className='row mb-4'>
                <div
                    className='col-auto my-auto '>
                    <Avatar
                        alt={app.app.name + 'App icon'}
                        src={app.app.icon}
                        size='lg'
                        sx={{
                            width: 82,
                            height: 82,
                            borderRadius: '24%',
                        }}>
                        {helper.getInitials(app.app.name)}
                    </Avatar>
                </div>
                <div
                    className='col my-auto'>
                    <Typography
                        level='title-lg'
                        sx={{
                            fontWeight: 700,
                        }}>
                        {app.app.name}
                        <span className='ms-2'>
                            <Typography
                                level='body-xs'
                                sx={{
                                    color: 'text.secondary',
                                    marginBottom: 2,
                                }}>
                                <Chip
                                    variant="solid"
                                    color="primary"
                                    size="sm"
                                    sx={{
                                        marginLeft: 1,
                                        color: 'white'
                                    }}
                                >
                                    #{app.app.position_in_category}
                                </Chip>
                                <span className='ms-2'>
                                    in {app.app.apple_genres[0]}
                                </span>
                            </Typography>
                        </span>
                    </Typography>
                    <Typography
                        level='body-xs'
                        sx={{
                            color: 'text.secondary',
                            marginTop: 1,
                            marginBottom: 2
                        }}>
                        {getAppSummary()}
                    </Typography>
                    <Typography
                        level='body-xs'>
                        {stores()}
                    </Typography>
                </div>
            </div>
            <Divider
                sx={{ marginY: 3 }}
            />
            {/* App Information Cards */}
            <div className='d-flex flex-row gap-3 mb-3'>
                {app.app.appleappid &&
                    <AppRatingComponent
                        app={app.app}
                        type={'apple'} />
                }
                {app.app.androidpackageid &&
                    <AppRatingComponent
                        app={app.app}
                        type={'google'} />
                }
                {app.app.app_gallery_id &&
                    <AppRatingComponent
                        app={app.app}
                        type={'appgallery'} />
                }
            </div>
            {/* App Information Overview */}
            <AppInfoOverviewComponent
                app={app.app}
            />
            <div className='p-0 mt-3'>
                <div className='row gy-3 gx-3' >
                    <div className='col-lg-4'>
                        <NotificationAlertComponent
                            app={app.app} />
                    </div>
                    <div className='col-lg-4'>
                        <Card
                            sx={{
                                padding: 3,
                                ...cardStyles.base
                            }}>
                            <SentimentGaugeComponent
                                app={app.app} />
                        </Card>
                    </div>
                    <div className='col-lg-4'>
                        <Card
                            sx={{
                                padding: 3,
                                height: 100 + '%',
                                ...cardStyles.base
                            }}>
                            <SentimentBreakdownComponent
                                app={app.app} />
                        </Card>
                    </div>
                </div>
            </div>
            <div className='p-0 mt-3'>
                <Card
                    sx={{
                        ...cardStyles.base
                    }}>
                    <Typography
                        color='neutral'
                        fontWeight={600}
                        level='body-xs'>
                        {"Top keywords".toUpperCase()}
                        <InfoTooltipComponent
                            message={"Distribution of top keywords mentioned in user reviews."}
                            size={'sm'}
                            variant={'plain'}
                            color={'primary'} />
                    </Typography>
                    <Divider />
                    <TopKeywordsComponent
                        app={app.app}
                        limit={5}
                        state={''} />
                </Card>
            </div>
        </div >
    )
}

export default DashboardComponent;